import React from 'react';
import Input from '../../../components/UI/inputs/Input';
import './style.css';
import useForm from './useForm';
import { useTranslation } from 'react-i18next';

const Contact = () => {
  const { submitHandler, loading, field } = useForm();
  const { t, i18n } = useTranslation();

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <div className="contact-hero">
        <div className="contact-hero-content">
          <h1 className="contact-hero-title">
            <i className="fas fa-envelope me-3"></i>
            {t('contact.heroTitle')}
          </h1>
        </div>
      </div>

      {/* Contact Form Section */}
      <div className="contact-form-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="contact-form-container">
                <div className="contact-form-header">
                  <h2 className="contact-form-title">
                    <i className="fas fa-paper-plane me-2"></i>
                    {t('contact.form.title')}
                  </h2>
                  <p className="contact-form-subtitle">
                    {t('contact.form.subtitle')}
                  </p>
                </div>
                
                <form onSubmit={submitHandler}>
                  <div className="row">
                    <div className="col-md-6 mb-4">
                      <Input
                        type="text"
                        placeholder={t('contact.form.placeholderTopic')}
                        label={t('contact.form.topic')}
                        {...field('topic')}
                      />
                    </div>
                    <div className="col-md-6 mb-4">
                      <Input
                        type="email"
                        placeholder={t('contact.form.placeholderEmail')}
                        label={t('contact.form.email')}
                        {...field('email')}
                      />
                    </div>
                    <div className="col-12 mb-4">
                      <Input
                        type="text"
                        placeholder={t('contact.form.placeholderMessage')}
                        label={t('contact.form.message')}
                        {...field('message')}
                        multiline
                        rows={5}
                      />
                    </div>
                    <div className="col-12 text-center">
                      <button 
                        type="submit" 
                        className="btn btn-contact-send" 
                        disabled={loading}
                      >
                        {loading ? (
                          <>
                            <i className="fas fa-spinner fa-spin me-2"></i>
                            {t('contact.form.sending')}
                          </>
                        ) : (
                          <>
                            <i className="fas fa-paper-plane me-2"></i>
                            {t('contact.form.send')}
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Info Section */}
      <div className="contact-info-bottom">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="contact-info-compact">
                <div className="row">
                  <div className="col-md-4 text-center mb-3">
                    <div className="contact-info-item">
                      <i className="fas fa-map-marker-alt"></i>
                      <h6>{t('contact.info.address.title')}</h6>
                      <p>{t('contact.info.address.text')}</p>
                    </div>
                  </div>
                  <div className="col-md-4 text-center mb-3">
                    <div className="contact-info-item">
                      <i className="fas fa-phone"></i>
                      <h6>{t('contact.info.phone.title')}</h6>
                      <p>{t('contact.info.phone.text')}</p>
                    </div>
                  </div>
                  <div className="col-md-4 text-center mb-3">
                    <div className="contact-info-item">
                      <i className="fas fa-envelope"></i>
                      <h6>{t('contact.info.email.title')}</h6>
                      <p>{t('contact.info.email.text')}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Map Section */}
      <div className="contact-map-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="map-header text-center mb-4">
                <h2 className="map-title">
                  <i className="fas fa-map-marked-alt me-2"></i>
                  {t('contact.map.title')}
                </h2>
                <p className="map-subtitle">{t('contact.map.subtitle')}</p>
              </div>
              
              <div className="maps-container">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3196.531535773876!2d3.0074840999999997!3d36.7578142!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x128fb1ee2a40b4bf%3A0x7fbfdad9bc35232d!2sOffice%20des%20Publications%20Universitaires%20OPU!5e0!3m2!1sfr!2sdz!4v1761441259792!5m2!1sfr!2sdz"
                  width="100%"
                  height="400"
                  style={{ border: 0, borderRadius: '15px' }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Office des Publications Universitaires OPU - Algiers"
                ></iframe>
              </div>
              
              <div className="map-info mt-4">
                <div className="row justify-content-center">
                  <div className="col-md-8">
                    <div className="map-details-card">
                      <div className="row align-items-center">
                        <div className="col-md-6">
                          <div className="map-detail-item">
                            <i className="fas fa-map-marker-alt text-primary me-2"></i>
                            <span>{t('contact.info.address.text')}</span>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="map-detail-item">
                            <i className="fas fa-directions text-primary me-2"></i>
                            <a 
                              href="https://maps.google.com/?q=1+Place+Ben+Aknoun+Central+Algiers+Algeria" 
                              target="_blank" 
                              rel="noopener noreferrer"
                              className="text-decoration-none"
                            >
                              {t('contact.map.getDirections')}
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
